'use client';

import Link from 'next/link';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';
import styles from '../styles/Home.module.css';

function slugifyRoomName(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-_\s]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

export default function Page() {
  const router = useRouter();
  const [roomName, setRoomName] = useState('interpreter-realista-demo');

  const onSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    const normalized = slugifyRoomName(roomName);
    if (!normalized) return;
    router.push(`/rooms/${normalized}`);
  };

  return (
    <>
      <main className={styles.main} data-lk-theme="default">
        <div className="header">
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 12,
              justifyContent: 'center',
              marginBottom: 12,
            }}
          >
            <span
              aria-hidden="true"
              style={{
                width: 36,
                height: 36,
                borderRadius: 8,
                background: 'linear-gradient(135deg, #2f81f7, #37d67a)',
                boxShadow: '0 14px 34px rgba(47, 129, 247, 0.24)',
              }}
            />
            <span style={{ color: '#edf4fb', fontSize: 42, fontWeight: 820, lineHeight: 1 }}>
              AmpereEdge Meet
            </span>
          </div>
          <h2>
            Reuniones con agentes, interpretes de voz y bitacoras exportables para AmpereEdge.
          </h2>
        </div>

        <form className={styles.tabContent} onSubmit={onSubmit}>
          <p style={{ marginTop: 0 }}>
            Escribe el nombre de la sala y entra. La pantalla siguiente te pedira tu nombre y tus
            dispositivos antes de unirte.
          </p>
          <input
            id="roomName"
            name="roomName"
            type="text"
            value={roomName}
            onChange={(event) => setRoomName(event.target.value)}
            placeholder="interpreter-realista-demo"
            required
          />
          <button
            style={{ paddingInline: '1.25rem', width: '100%' }}
            className="lk-button"
            type="submit"
          >
            Entrar a la sala
          </button>
          <Link
            href="/interpreter-reports"
            style={{
              minHeight: 40,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              borderRadius: 8,
              border: '1px solid rgba(148, 163, 184, 0.24)',
              background: 'rgba(15, 23, 42, 0.72)',
              color: '#dbe7f4',
              fontSize: 14,
              fontWeight: 760,
              textDecoration: 'none',
            }}
          >
            Ver reportes de interprete
          </Link>
        </form>
      </main>
      <footer data-lk-theme="default">
        AmpereEdge Meet / laboratorio de reuniones con agentes
      </footer>
    </>
  );
}
